import { ReducersTypes } from "@/redux/reducers/Models";

export interface ResponseCardValidation {
  data: {
    data: {
      validCard: boolean;
      validationToken: string;
      eligibleUpdatePlan: boolean;
      hash: string;
      partner: string;
      plan?: {
        name?: string;
        price?: number;
      };
    };
  };
}

export interface ResponseEncryptedCard {
  data: {
    token: string;
    additionalInformation: {
      issuer: {
        id: string;
      };
      brand: {
        name: string;
      };
    };
  };
}

export interface Flag {
  descricaoBandeira: string;
  codigoBandeira: string;
}

export interface ResponseFlags {
  data: {
    listaBandeiraCartao: Flag[];
  };
}

export const getCurrentFlagId = (allowedFlags: Flag[], current: string) => {
  return allowedFlags?.find((flag) => flag.descricaoBandeira === current)
    ?.codigoBandeira;
};

export const getCustomer = (state: ReducersTypes) => state.customerReducer;

export const getFormattedValue = (value: string | number) => {
  return `R$ ${Number(value ?? 0)
    .toFixed(2)
    .toString()
    .replace(/\./g, ",")}`;
};
